import React from 'react';
import { Toolbar, Button, AppBar, Typography } from '@material-ui/core'

const NavBar = ({ title, showLogout, handleLogout }) => {

    return (
        <div style={{ flexFlow: 1 }}>
            <AppBar position="fixed">
                <Toolbar>
                    <Typography variant="title" color="inherit" style={{ flexGrow: 1 }}>
                        {title}
                    </Typography>

                    { showLogout? 
                        <Button size="small" 
                                color="inherit"
                                onClick={() => handleLogout()}>
                                    Logout
                        </Button> : null }
                    
                </Toolbar>
            </AppBar>
        </div>
    )
}
export default NavBar;




// WEBPACK FOOTER //
// ./src/components/NavBar.js